// extracted by mini-css-extract-plugin
export default {"input":"A8-z","button":"B8-z","selected":"C8-z","unavailable":"D8-z","oos":"E8-z","image":"F8-z","paperCutDisabledOverlay":"G8-z"};